import { APIClient } from "../api";

export default class ClassificationGroupService extends APIClient {

    async getClassificationGroupByService(serviceId: number) {
        const url = `${this.endpoint}/ClassificationGroup/Service/${serviceId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getClassificationGroupByServiceAndBusinessArea(serviceId: number, businessAreaId: number) {
        const url = `${this.endpoint}/ClassificationGroup/Service/${serviceId}/BusinessUnit/${businessAreaId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getClassificationGroupByBusinessUnit(serviceId: number, businessUnit: number) {
        const url = `${this.endpoint}/ClassificationGroup/BusinessUnit/${businessUnit}/${serviceId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getClassificationGroup() {
        const url = `${this.endpoint}/ClassificationGroup`;

        return this.api({
            method: 'get',
            url
        });
    }
    async getClassificationGroupById(id: number) {
        const url = `${this.endpoint}/ClassificationGroup/${id}`;

        return this.api({
            method: 'get',
            url
        });
    }

}